import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import type { BasicListOption } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const getValueLabel = <T>(currentValue: T, listOption: BasicListOption<T>[]): string => {
  return currentValue == null
    ? ''
    : listOption.find((item) => item.value === currentValue)?.label ?? '';
};

export const getLabels = <T>(
  currentValue: T | undefined,
  filterKind: FilterKindEnum,
  listOption: BasicListOption<T>[],
): LabelProps => {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue, listOption),
  };
};
